import axios from "axios";
import encryptData from "../Utils/encryption";

let URL = process.env.REACT_APP_PL_API;
console.log(URL, "API");
const API = axios.create({ 
  baseURL: URL,
  withCredentials: true  // Enable cookies for HTTP-only authentication
});
const getAccessToken = (client) => { 
  if(!client){
    return process.env.REACT_APP_XACCESSTOKEN;
  }
  switch (client) {
    case "axis":
      return process.env.REACT_APP_AXIS_ACCESS_TOKEN;
    case "hdfc":
      return process.env.REACT_APP_HDFC_ACCESS_TOKEN;
    case "hdfc_concierge":
      return process.env.REACT_APP_HDFC_CONCIERGE_ACCESS_TOKEN;
    case "hc":
      return process.env.REACT_APP_HC_ACCESS_TOKEN;
    case "eai_auto":
      return process.env.REACT_APP_EAI_AUTO_ACCESS_TOKEN;
    case "ts":
      return process.env.REACT_APP_TS_ACCESS_TOKEN;
    case "ebix":
      return process.env.REACT_APP_EBIX_ACCESS_TOKEN;
    case "moto":
      return process.env.REACT_APP_MOTO_ACCESS_TOKEN;
    case "eai_crm":
      return process.env.REACT_APP_EAI_CRM_ACCESS_TOKEN;
    case "vahan":
      return process.env.REACT_APP_VAHAN_ACCESS_TOKEN;
    case "cyberior":
      return process.env.REACT_APP_CYBERIOR_ACCESS_TOKEN;
    default:
      return process.env.REACT_APP_XACCESSTOKEN;
  }

  }

API.interceptors.request.use(
  (config) => {
    const { store } = require("../store/store");
    const { selectedClient } = store.getState().clients;
    let token = getAccessToken(selectedClient?.value);
    console.log("Selected Client:", selectedClient?.value,config.headers);

    // Support explicit tenantId config option (e.g. { tenantId: "hdfc" })
    if (config.tenantId) {
      config.headers["x-tenant-id"] = config.tenantId;
      token = getAccessToken(config.tenantId);
      delete config.tenantId;
    } else {
      config.headers["x-tenant-id"] = selectedClient?.value || "hdfc"; // Default to "hdfc" if no client selected
      token = getAccessToken(config.headers["x-tenant-id"]);
    }
    config.headers["x-access-token"] = token;

    const { selectedClientRecord } = store.getState().clients;
    if (selectedClientRecord?.value) {
      config.headers["x-client-id"] = String(selectedClientRecord.value);
    }

    // if (selectedClient?.value) {
    //   config.headers["x-tenant-id"] = selectedClient.value;
    // }

    if(config.data){
      const encryptedData = encryptData(JSON.stringify(config.data));
      config.data = { data: encryptedData?.data };
      config.headers["x-encrypted-key"] = encryptedData.encryptedKey;
      config.headers["x-iv"] = encryptedData.iv;
    }
    
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Security Fix: Add response interceptor to handle authentication errors
API.interceptors.response.use(
  function (response) {
    // Return successful responses as-is
    return response;
  },
  function (error) {
    // Handle authentication errors
    if (error.response && (error.response.status === 401)) {
      console.error("Authentication failed - clearing session");
      
      // Clear all authentication data from localStorage
      localStorage.removeItem("login");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("Name");
      localStorage.removeItem("profileURL");
      
      // Redirect to login page if not already there
      if (!window.location.pathname.includes("/login")) {
        window.location.href = `${process.env.PUBLIC_URL}/login`;
      }
    }
    
    return Promise.reject(error);
  }
);

export { getAccessToken };
export default API;
